import { useTranslation } from '@silospot/i18n/react';
import { Radio } from 'lucide-react';
import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from './kit';

/**
 * Per-site empty state (C-fix): the selected site has no tracker yet, so its
 * analytics/security views would be all-zeros. Show a pedagogic state with a
 * route into the install flow (Settings → tracker) instead of faking data.
 * Settings stays reachable so the user can install from there.
 */
export function NoTracker({
  projectId,
  domain,
}: {
  projectId: string;
  domain: string;
}): ReactElement {
  const { t } = useTranslation('shell');
  const navigate = useNavigate();
  return (
    <Card className="mx-auto mt-6 max-w-md py-12 text-center">
      <span className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-2xl bg-accent-bg text-primary">
        <Radio className="h-6 w-6" />
      </span>
      <div className="text-[16px] font-bold text-text">{t('noTracker.title')}</div>
      <p className="mx-auto mt-1.5 max-w-xs text-[13px] leading-relaxed text-text-2">
        {t('noTracker.body', { site: domain })}
      </p>
      <button
        type="button"
        onClick={() => navigate(`/projects/${projectId}/settings`)}
        className="mt-4 inline-flex items-center gap-1.5 rounded-[9px] bg-primary px-4 py-2 text-[13px] font-semibold text-white hover:opacity-90"
      >
        {t('noTracker.cta')}
      </button>
    </Card>
  );
}
